<template>
  <ViceButton
    @click="handleStethoscopeConnection"
    circle
    white
    :showNotification="isActive"
    style="padding: 0 !important"
    :btnDescription="btnDescription"
    :class="{ 'sm:bg-vice-teal-600 hover:bg-vice-teal-700': isActive }"
    class="w-12 h-12 border-none bg-vice-light-grey"
    :disabled="isConnected || loading"
  >
    <ViceLoader colorClass="text-vice-teal-700" class="left-2" v-if="loading" />

    <template v-else>
      <ViceStethoscope class="w-12 h-12" :pathFill="!isActive ? '#0F766E' : '#fff'" />
    </template>
  </ViceButton>
</template>

<script>
import { computed, ref } from 'vue';
import useSessionStore from '@/Stores/useSessionStore';
import useLocalStreamingDevicesStore from '@/Stores/useLocalStreamingDevicesStore';
import ViceButton from '@/Components/Buttons/ViceButton.vue';
import ViceStethoscope from '../Icons/ViceStethoscope.vue';
import ViceLoader from '../Loaders/ViceLoader.vue';
import { STETHOSCOPE_LABELS, EXTERNAL_CONNECTED_AUDIO_DEVICES } from '@/Utils/vice-constants';

export default {
  name: 'AddStethoscopeButton',
  components: {
    ViceButton,
    ViceStethoscope,
    ViceLoader,
  },
  setup() {
    const loading = ref(false);
    const multiCameraDevicesStore = useLocalStreamingDevicesStore();
    const sessionStore = useSessionStore();
    const isActive = computed(() =>
      multiCameraDevicesStore.allExternalConnectedAudioDevices.find(
        (deviceName) => deviceName === EXTERNAL_CONNECTED_AUDIO_DEVICES.STETHOSCOPE,
      ),
    );
    const isConnected = computed(
      () =>
        !multiCameraDevicesStore.groupedDeviceAsAudioAndVideo.AUDIO.Microphone.find((device) =>
          STETHOSCOPE_LABELS.some((singleLabel) => device.label.includes(singleLabel)),
        ),
    );

    const btnDescription = computed(() =>
      isActive.value
        ? `Disconnect ${EXTERNAL_CONNECTED_AUDIO_DEVICES.STETHOSCOPE}`
        : `Connect ${EXTERNAL_CONNECTED_AUDIO_DEVICES.STETHOSCOPE}`,
    );

    const handleStethoscopeConnection = async () => {
      try {
        loading.value = true;
        sessionStore.toggleControlPanel(true);

        if (isActive.value) {
          await multiCameraDevicesStore.removeExternalAudioDevice(
            EXTERNAL_CONNECTED_AUDIO_DEVICES.STETHOSCOPE,
          );
          sessionStore.showStethGuide = false;
        } else {
          await multiCameraDevicesStore.addExternalAudioDevice(
            sessionStore.sessionId,
            EXTERNAL_CONNECTED_AUDIO_DEVICES.STETHOSCOPE,
            STETHOSCOPE_LABELS,
          );

          sessionStore.showStethGuide = true;
        }
        multiCameraDevicesStore.markSessionSetupAsChanged();
      } catch (error) {
        console.error({ error });
      } finally {
        loading.value = false;
      }
    };

    return {
      isConnected,
      isActive,
      loading,
      btnDescription,
      handleStethoscopeConnection,
    };
  },
};
</script>
